import { SVGProps } from 'react'
import SVGUniqueID from 'react-svg-unique-id'

import { GRADIENTS } from 'configs/iconColors'

type Props = {
  color?: [start: string, stop: string] | string
  type?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info'
} & Omit<SVGProps<SVGSVGElement>, 'color'>

export function Sms({ color, type, ...props }: Props) {
  const c = color || GRADIENTS[type || 'secondary']
  const fill = typeof c === 'string' ? [c, c] : c

  return (
    <SVGUniqueID>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M1.4466 10.4072H6.58892L10.9676 14V10.4072H12.5487C13.3465 10.4072 13.9953 9.74692 13.9953 8.93499V1.47222C13.9953 0.660292 13.3465 0 12.5487 0H1.4466C0.648781 0 0 0.660292 0 1.47222V8.93496C0 9.74689 0.648781 10.4072 1.4466 10.4072ZM10.3952 5.54762C9.83232 5.358 9.61493 5.05176 9.62047 4.72844C9.62047 4.22146 10.0553 3.83708 10.7292 3.83708C11.047 3.83708 11.331 3.90925 11.4985 3.99297L11.3481 4.57809C11.2255 4.51102 10.9915 4.42177 10.7574 4.42177C10.5511 4.42177 10.4341 4.50548 10.4341 4.64472C10.4341 4.77285 10.54 4.83991 10.8745 4.95693C11.3925 5.13504 11.6099 5.39727 11.6155 5.79833C11.6155 6.30531 11.2145 6.67858 10.4341 6.67858C10.0775 6.67858 9.75971 6.60083 9.55387 6.48939L9.70422 5.88205C9.86011 5.97687 10.1834 6.08835 10.4341 6.08835C10.6904 6.08835 10.7963 5.99909 10.7963 5.85986C10.7963 5.72019 10.7126 5.65355 10.3952 5.54762ZM5.60957 3.89817L5.64844 4.26591H5.66509C5.78211 4.09336 6.02172 3.83711 6.48981 3.83711C6.8409 3.83711 7.11937 4.01522 7.23639 4.29924H7.2475C7.34787 4.16 7.47046 4.04852 7.59858 3.97081C7.74936 3.88155 7.91633 3.83714 8.1171 3.83714C8.64072 3.83714 9.03664 4.20487 9.03664 5.01808V6.62314H8.21192V5.1411C8.21192 4.74517 8.08336 4.51668 7.81046 4.51668C7.61569 4.51668 7.47603 4.65035 7.4205 4.81224C7.39828 4.8733 7.3872 4.96259 7.3872 5.02962V6.62314H6.56248V5.09626C6.56248 4.75071 6.43989 4.51668 6.17209 4.51668C5.95511 4.51668 5.82655 4.68411 5.7766 4.82335C5.74884 4.88998 5.74329 4.96813 5.74329 5.03519V6.62317H4.91857V4.76742C4.91857 4.42788 4.90746 4.13786 4.89635 3.89826H5.60957V3.89817ZM3.18618 5.54762C2.62326 5.358 2.40588 5.05176 2.41142 4.72844C2.41142 4.22146 2.84621 3.83708 3.52019 3.83708C3.83797 3.83708 4.12241 3.90925 4.28938 3.99297L4.13903 4.57809C4.01645 4.51102 3.78241 4.42177 3.54835 4.42177C3.34205 4.42177 3.22503 4.50548 3.22503 4.64472C3.22503 4.77285 3.33094 4.83991 3.66537 4.95693C4.18345 5.13504 4.40083 5.39727 4.4064 5.79833C4.4064 6.30531 4.00537 6.67858 3.22503 6.67858C2.86841 6.67858 2.55063 6.60083 2.34478 6.48939L2.49513 5.88205C2.65102 5.97687 2.97434 6.08835 3.22506 6.08835C3.48131 6.08835 3.58725 5.99909 3.58725 5.85986C3.58725 5.72019 3.50353 5.65355 3.18618 5.54762Z"
          fill="url(#paint0_linear_1_611)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1_611"
            x1="0"
            y1="0"
            x2="0"
            y2="14"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={fill[0]} />
            <stop offset="1" stopColor={fill[1]} />
          </linearGradient>
        </defs>
      </svg>
    </SVGUniqueID>
  )
}
